import { useTranslation } from "react-i18next"

import Bone from "../../../../Components/Skeleton/Bone"
import { CHANNEL_COUNT } from "../../utils/vocabulary"

import styles from "./channelDonut.module.less"

const MUTED = { color: "#7A7A83" }

// The donut (74% cutout) and the legend reasonLegendPlugin builds, in its own markup and
// classes so the rows land at the same 48px height: the header is real text, the three
// channel rows are bars.
const ChannelDonutSkeleton = () => {
  const { t } = useTranslation()

  return (
    <>
      <div className={`${styles.donut} ${styles.ringWrap}`}>
        <Bone width={240} height={240} radius="50%" className={styles.ring} />
      </div>
      <div className={styles.legend}>
        <ul className="ul-wrapper">
          <li>
            <div className="first_line">
              <p style={{ ...MUTED, flex: "1 1 0", minWidth: 0 }}>{t("Category")}</p>
              <p style={{ ...MUTED, flex: "0 0 20%", textAlign: "center" }}>{t("Count")}</p>
              <p style={{ ...MUTED, flex: "0 0 28%", textAlign: "end", whiteSpace: "nowrap" }}>
                {t("Volume ($)")}
              </p>
            </div>
          </li>
          {Array.from({ length: CHANNEL_COUNT }, (_, i) => (
            <li key={i}>
              <div className="first_line">
                <span className={styles.skeletonName}>
                  <Bone width={8} height={8} />
                  <Bone width={96} height={14} />
                </span>
                <span className={styles.skeletonCount}>
                  <Bone width={40} height={14} />
                </span>
                <span className={styles.skeletonVolume}>
                  <Bone width={64} height={14} />
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}

export default ChannelDonutSkeleton
